
import CompoundNewComponent from "../../../components/compounds/New.vue";

export default {
  components: {
    CompoundNewComponent
  }
};
